export enum KindStatus {
  Archived = "archived",
  Live = "live"
}

